// Self-contained copy of the generic Eligibility/Formula rule-builder labels (modules/common/Builder),
// decoupled from the `rewards` CMS section — matches the pattern used by ltiPlans/fixedCosts, so
// future edits to Rewards labels don't affect Bonus Modeller and vice versa.
export default {
  ELIGIBILITY_GENERIC_LABEL: 'Eligibility',
  ELIGIBILITY_NEW_BLOCK_PLACEHOLDER:
    'Start by adding an %eligibility criterion% or leave it as is to apply to all %country% employees.',
  ELIGIBILITY_RULE_VARIABLE_NAME: 'Variable name',
  ELIGIBILITY_RULE_OPERATOR: 'Operator',
  ELIGIBILITY_RULE_VALUE: 'Value',
  ELIGIBILITY_VARIABLE_PLACEHOLDER: 'Variable',
  ELIGIBILITY_OPERATOR_PLACEHOLDER: 'Operator',
  ELIGIBILITY_VALUE_PLACEHOLDER: 'Value',
  ELIGIBILITY_VALUE_SELECT_PLACEHOLDER: 'Type to search value',
  ELIGIBILITY_CREATEABLE_SELECT_PLACEHOLDER: 'Type to add values',
  ELIGIBILITY_AND_OPERATOR: 'AND',
  ELIGIBILITY_OR_OPERATOR: 'OR',
  ELIGIBILITY_IF_KEYWORD: 'IF',
  ELIGIBILITY_DELETE_RULE: 'Delete rule',
  ELIGIBILITY_DUPLICATE_RULE: 'Duplicate rule',
  ELIGIBILITY_DELETE_GROUP: 'Delete group',
  ELIGIBILITY_DUPLICATE_GROUP: 'Duplicate group',

  RULES_BUILDER_ADD: 'Add',
  RULES_BUILDER_DUPLICATE: 'Duplicate',
  RULES_BUILDER_RULE_LABEL: 'Rule',
  RULES_BUILDER_EMPTY_FORMULA_ERROR_LABEL: 'Make sure you have at least one value or function.',
  RULES_BUILDER_INVALID_FORMULA_ERROR_LABEL: 'Please check the syntax of your formula.',
  RULES_BUILDER_VARIABLE_MISSING: 'Expression is required.',
  RULES_BUILDER_DETAILS_MISSING: 'Bonus details are required.',

  FORMULA_GENERIC_LABEL: 'Value',
  FORMULA_SIMPLE_PLACEHOLDER:
    'Start by inserting a %value% or a function (%min%, %max%, %round%, %round up%, %round down%) or a %text-only% field.',
  FORMULA_MAX_FUNCTION_LABEL: 'Max',
  FORMULA_MIN_FUNCTION_LABEL: 'Min',
  FORMULA_ROUND_FUNCTION_LABEL: 'Round',
  FORMULA_ROUND_UP_FUNCTION_LABEL: 'Round Up',
  FORMULA_ROUND_DOWN_FUNCTION_LABEL: 'Round Down',
};
